import { useEffect } from "react";

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(selector.startsWith("link") ? "href" : "content", value);
  return el;
};

export const DEFAULT_TITLE = "PetTok Shop | Kiddee-Approved Dog Toys, Treats & Gear";

// Sets per-page title, meta description, canonical URL and Open Graph tags.
export const useSeo = ({ title, description, path, image }) => {
  useEffect(() => {
    const url = `https://pettokshop.net${path}`;
    document.title = title;
    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('link[rel="canonical"]', "rel", "canonical", url);
    setMeta('meta[property="og:title"]', "property", "og:title", title);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    if (image) setMeta('meta[property="og:image"]', "property", "og:image", image.startsWith("http") ? image : `https://pettokshop.net${image}`);
    return () => {
      document.title = DEFAULT_TITLE;
      document.head.querySelector('link[rel="canonical"]')?.remove();
    };
  }, [title, description, path, image]);
};
